import MAIN from './main';
import CLIPS from './clips-worker';
import CLIP_FIGURE from './clip-figure';
import GALLERY_CAROUSEL from './gallery-carousel';
import LIGHTBOX from './lightbox';
import VIRTUAL_TOUR from './virtual-tour';
import { constants } from '../../../../../../utils/octopus';

const { OWNERSHIPS } = constants;

const ClipsPlugin = {
  resolver: props => !!props?.clipsConfig?.hasClips,
  definitions: {
    ...MAIN,
    ...CLIP_FIGURE,
    ...CLIPS,
    ...GALLERY_CAROUSEL,
    ...LIGHTBOX,
    ...VIRTUAL_TOUR,
  },
  ownership: OWNERSHIPS.VPP,
  id: 'clips',
  deps: ['clipsConfig.hasClips'],
};

export default ClipsPlugin;
